import React from 'react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import Video from './Video';

const data=[
    {
        id:1,
        name:"Gregory",
        img:"https://raw.githubusercontent.com/wdridoy11/web-icon/main/greg.png",
        description:"Ridoy styled an entire Educational Website and did an excellent job. He was in excellent communication during the entire process, and his English is excellent. He was amazingly easy to work with, and I look forward to working with him again in future projects!",
        reating:5
    },
     
    {
      id:2,
      name:"Shakil",
      img:"https://raw.githubusercontent.com/wdridoy11/web-icon/d2ce003c003e2dadd30a3e7cc93fd9b5014f2945/Portfolio.png",
      description:"Great work! Working with WordPress has exceeded my expectations. Every request I had was met and exceeded. I will absolutely do work with Ridoy again and would certainly recommend her company to anyone in need of a professional WordPress expert and web designer. He was amazingly easy to work with, and I look forward to working with him again in future projects!",
      reating:5
    },
    {
      id:3,
      name:"Dash",
      img:"https://raw.githubusercontent.com/wdridoy11/web-icon/25b15e4914ec237a456504498a13fd4e33151658/u-2.png",
      description:"It was very nice working with Ridoy. Highly recommended. Thanks",
      reating:5
    },
    {
      id:5,
      name:"Alvaro",
      img:"https://raw.githubusercontent.com/wdridoy11/web-icon/3554e5aa263a116ea819deaa1030717044fd637a/u-4.png",
      description:"Excelent as always!!!!",
      reating:5
    }, 
    // {
    //   id:4,
    //   name:"Alvaro",
    //   img:"https://raw.githubusercontent.com/wdridoy11/web-icon/3554e5aa263a116ea819deaa1030717044fd637a/u-4.png",
    //   description:"Amazing designer",
    //   reating:5
    // },
    {
      id:6,
      name:"Brandon",
      img:"https://raw.githubusercontent.com/wdridoy11/web-icon/c1cdd94a5858cda3ed0a7c74da2c6c0e345452cf/u-1.png",
      description:"Contest winning entry",
      reating:5
}

]
const Testimonial = () => {



  return (
    <div className='bg-[#0E1629] py-20' id='testimonial'>
        <div className='container'>
          <div className='text-center pb-12'>
              <h1 className='text-5xl font-medium text-[#22d3ee]'>Testimonial</h1>
              <p className='text-base text-white'>What Clients Say</p>
          </div>
          <Video />
          <div className='grid grid-cols-3 gap-5'>
              {data.map((review)=><div className='bg-[#182233] p-5 rounded-md' key={review.id}>
                  <div className=' rounded-lg'>
                      <img className='w-20 h-20 object-cover mx-auto rounded-full ring-2 ring-[#22d3ee]' src={review.img} alt="client" />
                      <h3 className='text-base text-[#22d3ee] mt-5 mb-2 text-center'>{review.name}</h3>
                      <div className='text-center'>
                          <div className="rating">
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                          </div>
                      </div>
                      <p className='mt-2 text-gray-400 font-normal'>{review.description}</p>
                  </div>
                </div>
              )}
          </div>
          <div>
          </div>

             {/* <Swiper
                modules={[Navigation, Pagination, Scrollbar, A11y]}
                spaceBetween={25}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}>
                {data.map((review)=><SwiperSlide><div key={review.id}>
                      <div className='text-center p-2 md:p-7 rounded-lg mx-16'>
                          <img className='w-20 h-20 object-cover mx-auto rounded-full' src={review.img} alt="client" />
                          <h3 className='text-xl text-[#22d3ee] mt-5 mb-2'>{review.name}</h3>
                          <div className="rating">
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                            <input type="text" name="rating-2" className="mask mask-star-2 bg-[#FFC600]" />
                          </div>
                          <p className='text-base font-normal mt-5 text-white'>{review.description}</p>
                      </div>
                    </div>
                  </SwiperSlide>)}
              </Swiper> */}
       </div>
    </div>
  )
}



export default Testimonial